import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';
import { P } from './portal-permissions.constants';

const GOREV_READ = [P.GorevPanosu.Module, P.GorevPanosu.ProjeYonetimi];
const PROJE_READ = [P.GorevPanosu.ProjeYonetimi];
const PROJE_WRITE = [P.GorevPanosu.ProjeYonetimi];

function multiRead(
  pattern: string,
  permissionKeys: string[],
  methods: ('GET' | 'POST')[] = ['GET', 'POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys,
    access: 'read' as const,
  }));
}

function multiWrite(
  pattern: string,
  permissionKeys: string[],
  methods: ('GET' | 'POST')[] = ['POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys,
    access: 'write' as const,
  }));
}

/** Görev Panosu — ProjectWorkflow API eşlemesi (generator write/read düzeltmeleri dahil). */
export const GOREV_PANOSU_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =
  [
    ...multiRead('api/ProjectWorkflow/GetProjects', GOREV_READ, ['GET']),
    ...multiRead(
      'api/ProjectWorkflow/GetProjectWorkflowTemplates',
      GOREV_READ,
      ['GET'],
    ),

    ...multiRead('api/ProjectWorkflow/GetProjectById', PROJE_READ),
    ...multiRead('api/ProjectWorkflow/GetProjectProgress', PROJE_READ),
    ...multiRead('api/ProjectWorkflow/GetProjectTasks', PROJE_READ),
    ...multiRead('api/ProjectWorkflow/GetTemplateById', PROJE_READ),
    ...multiRead(
      'api/ProjectWorkflow/GetProjectWorkflowTemplateSteps',
      PROJE_READ,
      ['GET'],
    ),
    ...multiRead(
      'api/ProjectWorkflow/GetProjectQuestionOptions',
      PROJE_READ,
      ['GET'],
    ),
    ...multiRead(
      'api/ProjectWorkflow/GetTemplateQuestionOptions',
      PROJE_READ,
      ['GET'],
    ),

    ...multiWrite('api/ProjectWorkflow/ActivateProject', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/CreateProject', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/CreateTemplate', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/ApplyTemplateToProject', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/AddTemplateStep', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/AddTemplateQuestion', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/AddProjectQuestion', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/AddTemplateQuestionOption', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/UpdateTemplateStep', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/UpdateTemplateQuestion', PROJE_WRITE),
    ...multiWrite(
      'api/ProjectWorkflow/UpdateTemplateQuestionOption',
      PROJE_WRITE,
    ),
    ...multiWrite('api/ProjectWorkflow/SaveProjectAnswer', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/UpdateTaskStatus', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/UpdateSubTaskStatus', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/RebuildTasksFromAnswers', PROJE_WRITE),
    ...multiWrite('api/ProjectWorkflow/RemoveProjectQuestion', PROJE_WRITE),
    ...multiWrite(
      'api/ProjectWorkflow/RemoveTemplateQuestionOption',
      PROJE_WRITE,
    ),

    ...multiRead(
      'api/Emission/GetEmissionCategoryMethods',
      [P.GorevPanosu.ProjeYonetimi, P.EmisyonFaktorleri.KategoriMetotlari],
      ['GET'],
    ),
  ];
